import angular from 'angular';
import getSigningStatusClassName from '@/shared/utils/signingStatusClassName';

angular.module('commonServices').filter('signingStatus', function() {
  return getSigningStatusClassName;
});
